// extracted by mini-css-extract-plugin
module.exports = {"container":"dateRangeDisplay_container__2vFla","noBorder":"dateRangeDisplay_noBorder__1Doli"};